<template class="tinymce-editor">
  <div class="tinymce-editor">
    <div class="add-media">
      <j-upload
        v-if="showUpload"
        :multiple="false"
        file-type="file"
        accept=".mp4, .m4a, .mp3, .ogg, .mov"
        class="avatar-uploader"
        v-model="file"
        @zipFile="getFileList"
        text="添加音频/视频"
        :uploadUrl="'system-file-biz/resources/upload'"
      ></j-upload>
    </div>
    <Editor
      :id="teid"
      v-if="show"
      v-model="myValue"
      :init="init"
      :disabled="disabled"
      class="my_tinymce"
    >
    </Editor>
  </div>
</template>
<script>
import JUpload from '@/components/jeecg/JUploadModal';
import tinymce from 'tinymce/tinymce';
import Editor from '@tinymce/tinymce-vue';
import 'tinymce/themes/silver';
// 更多插件参考：https://www.tiny.cloud/docs/plugins/
import 'tinymce/plugins/image'; // 插入上传图片插件
import 'tinymce/plugins/preview';
import 'tinymce/plugins/table'; // 插入表格插件
import 'tinymce/plugins/lists'; // 列表插件
import 'tinymce/plugins/colorpicker';
import 'tinymce/plugins/textcolor';
import 'tinymce/plugins/fullscreen';
import 'tinymce/plugins/wordcount'; // 字数统计插件
import 'tinymce/icons/default';
const tinymcePath =
  !process.env.VUE_APP_PUBLIC_PATH || process.env.VUE_APP_PUBLIC_PATH == '/'
    ? ''
    : process.env.VUE_APP_PUBLIC_PATH;

export default {
  components: {
    Editor,
    JUpload,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showUpload: {
      type: Boolean,
      default: true,
    },
    teid: {
      type: String,
      default: 'my_tinymce',
    },
  },
  data() {
    return {
      init: {
        selector: this.teid,
        height: '500px',
        // 引入汉化组件
        language_url: tinymcePath + '/tinymce/langs/zh_CN.js',
        // 设定语言为中文
        language: 'zh_CN',
        // 加入主题
        skin_url: tinymcePath + '/tinymce/skins/ui/oxide',

        // 注册功能组件
        plugins:
          ' lists table image colorpicker textcolor wordcount fullscreen preview ',
        // 注册工具栏
        toolbar:
          ' bold italic underline strikethrough | fontsizeselect | forecolor backcolor | alignleft aligncenter alignright | image fullscreen preview | bullist numlist ',
        images_upload_handler: (blobInfo, success, failure) => {
          this.handleImgUpload(blobInfo, success, failure);
        },
        video_template_callback: function (data) {
          console.log(data);
          let src = data.source;
          return `<span class="mce-preview-object mce-object-video" contenteditable="false" data-mce-object="video" data-mce-p-allowfullscreen="allowfullscreen" data-mce-p-frameborder="no" data-mce-p-scrolling="no" data-mce-p-src=${src} data-mce-p-controls="controls" data-mce-html="%20"> <video width="100%" controls="controls"> <source src=${src}></source> </video> </span>`;
        },
        fontsize_formats: '8px 10px 12px 14px 18px 24px 28px 36px', // 第二步
        relative_urls: false,
        remove_script_host: false,
      },
      media_live_embeds: true,
      myValue: this.value,
      file: null,
      show: false,
    };
  },
  mounted() {
    this.$nextTick(() => {
      //在弹出窗（modal）上使用富文本编辑器，因为tinymce在modal前创建了 用v-if model弹出后是tinymce显示
      //这里为了不多增加参数，加了一个setTimeout，延迟tinymce的初始化及显示
      setTimeout(() => {
        this.show = true;
        tinymce.init(this.init);
      }, 200);
    });
  },
  destroyed() {
    tinymce.remove();
  },
  methods: {
    getFileList(src) {
      if (src && src.fileUrl) {
        let embedHtml = `<span class="mce-preview-object mce-object-video" contenteditable="false" data-mce-object="video" data-mce-p-allowfullscreen="allowfullscreen" data-mce-p-frameborder="no" data-mce-p-scrolling="no" data-mce-p-src=${src} data-mce-p-controls="controls" data-mce-html="%20"> <video width="100%" controls="controls"> <source src=${src.fileUrl}></source> </video> </span>`;
        tinymce.get(this.teid).insertContent(embedHtml);
        this.$message.success('添加成功!');
      } else {
        this.$message.error('请先上传视频!');
      }
    },
    addHtml(html) {
      tinymce.get(this.teid).insertContent(html);
    },
    // 上传本地 图片执行事件
    handleImgUpload(blobInfo, success, failure) {
      let formdata = new FormData();
      formdata.append('file', blobInfo.blob());
      this.$http
        .post('system-file-biz/resources/upload', formdata)
        .then((res) => {
          success(res.result);
        });
    },
    // 上传本地 图片执行事件
    // handleMediaUpload(blobInfo, success, failure) {
    //   let formdata = new FormData();
    //   formdata.append('file', blobInfo.blob());
    //   this.$http.post('system-file-biz/minio/upload', formdata).then(res => {
    //     success(res.result.url);
    //   });
    // }
  },
  watch: {
    value(val) {
      this.myValue = val;
    },
    myValue(val) {
      this.$emit('change', val);
    },
  },
};
</script>
<style lang="less">
.my_tinymce {
  line-height: 1.5;
  width: 100%;
}
.tinymce-editor {
  position: relative;
  .add-media {
    position: absolute;
    right: 4px;
    top: 0;
    z-index: 1;
    line-height: 40px;
  }
  .ant-upload-list {
    display: none;
  }
}
</style>
